import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../profile/styles.css';

export default function ProfileArtistHelpSubscriptionsStudioPage() {
  const t = useTranslations('artist_help.subscriptions_studio');
  const [openSections, setOpenSections] = useState({
    overview: false,
    howStudioWorks: false,
    subscribersGet: false,
    studioOnlyContent: false,
    preferredBuyOption: false,
    representedAccess: false,
    giftingSubscriptions: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/artist-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('overview')}
            aria-expanded={openSections.overview}
          >
            <h2>{t('sections.overview.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.overview ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.overview && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.overview.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('howStudioWorks')}
            aria-expanded={openSections.howStudioWorks}
          >
            <h2>{t('sections.how_studio_works.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.howStudioWorks ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.howStudioWorks && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.how_studio_works.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('subscribersGet')}
            aria-expanded={openSections.subscribersGet}
          >
            <h2>{t('sections.what_subscribers_get.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.subscribersGet ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.subscribersGet && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.what_subscribers_get.p1')}</p>
              <ul>
                <li>{t('sections.what_subscribers_get.list_1')}</li>
                <li>{t('sections.what_subscribers_get.list_2')}</li>
                <li>{t('sections.what_subscribers_get.list_3')}</li>
                <li>{t('sections.what_subscribers_get.list_4')}</li>
              </ul>
              <p>{t('sections.what_subscribers_get.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('studioOnlyContent')}
            aria-expanded={openSections.studioOnlyContent}
          >
            <h2>{t('sections.studio_only_content.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.studioOnlyContent ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.studioOnlyContent && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.studio_only_content.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('preferredBuyOption')}
            aria-expanded={openSections.preferredBuyOption}
          >
            <h2>{t('sections.preferred_buy_option.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.preferredBuyOption ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.preferredBuyOption && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.preferred_buy_option.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('representedAccess')}
            aria-expanded={openSections.representedAccess}
          >
            <h2>{t('sections.represented_access.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.representedAccess ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.representedAccess && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.represented_access.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('giftingSubscriptions')}
            aria-expanded={openSections.giftingSubscriptions}
          >
            <h2>{t('sections.gifting_subscriptions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.giftingSubscriptions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.giftingSubscriptions && (
            <div className="artist-help-category__accordion-content">
              <div className="artist-help-category__stack">
                <h3>{t('sections.gifting_subscriptions.supporters_question_title')}</h3>
                <p>{t('sections.gifting_subscriptions.supporters_question_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.gifting_subscriptions.artist_question_title')}</h3>
                <p>{t('sections.gifting_subscriptions.artist_question_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.gifting_subscriptions.off_platform_title')}</h3>
                <p>{t('sections.gifting_subscriptions.off_platform_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.gifting_subscriptions.on_platform_title')}</h3>
                <p>{t('sections.gifting_subscriptions.on_platform_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.gifting_subscriptions.how_25_month_works_title')}</h3>
                <ul>
                  <li>{t('sections.gifting_subscriptions.how_25_month_works_list_1')}</li>
                  <li>{t('sections.gifting_subscriptions.how_25_month_works_list_2')}</li>
                </ul>
                <p>{t('sections.gifting_subscriptions.how_25_month_works_p1')}</p>
              </div>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
